import Box from '../../src/legacy/Box';
export default Box;
